import React from 'react';

/**
 * Card-shaped skeleton placeholder grid for listing sections.
 * Renders 3 cards on desktop, 1 on mobile, matching the structure
 * of the actual listing card (image, title, subtitle, chips, button).
 */
const CardSkeletonGrid: React.FC<{ count?: number }> = ({ count = 3 }) => {
  return (
    <section className="container mx-auto px-4 py-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className="rounded-xl border border-border bg-card overflow-hidden"
          >
            {/* Image placeholder */}
            <div className="h-48 bg-muted animate-pulse rounded-t-xl" />

            <div className="p-4 space-y-3">
              {/* Title + small badge */}
              <div className="flex items-center justify-between gap-2">
                <div className="h-4 bg-muted animate-pulse rounded-md w-[70%]" />
                <div className="h-4 bg-muted animate-pulse rounded-md w-[25%]" />
              </div>
              {/* Subtitle */}
              <div className="h-3 bg-muted animate-pulse rounded-md w-[85%]" />

              {/* 3 small chips */}
              <div className="flex gap-2 pt-1">
                <div className="h-5 bg-muted animate-pulse rounded-md w-12" />
                <div className="h-5 bg-muted animate-pulse rounded-md w-14" />
                <div className="h-5 bg-muted animate-pulse rounded-md w-10" />
              </div>

              {/* Button */}
              <div className="h-9 bg-muted animate-pulse rounded-md w-full mt-2" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CardSkeletonGrid;
